import { useTranslation } from "@impero-com/common/utils/i18n";
import Skeleton from "react-loading-skeleton";

import { DashboardCard } from "./dashboardCard/DashboardCard";
import * as theme from "./DashboardCardsSkeleton.css";

export function DashboardCardsSkeleton() {
    const { t } = useTranslation();
    return (
        <div className={theme.skeletonContainer}>
            <DashboardCard
                title={t("Dashboard_Card_Title_CompletionRate")}
                tooltipText={t("Dashboard_Card_Tooltip_CompletionRate")}
                showTooltip={true}
            >
                <Skeleton circle height={230} width={230} />
            </DashboardCard>
            <DashboardCard
                title={t("Dashboard_Card_Title_OnTimeRate")}
                tooltipText={t("Dashboard_Card_Tooltip_OnTimeRate")}
                showTooltip={true}
            >
                <Skeleton circle height={230} width={230} />
            </DashboardCard>
            <DashboardCard
                title={t("Dashboard_Card_Title_Activities")}
                showTooltip={false}
            >
                <Skeleton circle height={180} width={180} />
                <div className={theme.skeletonRows}>
                    <Skeleton count={2} width={150} height={15} />
                    <Skeleton count={3} width={100} height={15} />
                </div>
            </DashboardCard>
        </div>
    );
}
